import { Heading, Img } from "./..";
import React from "react";

interface Props {
  className?: string;
  imageSrc?: string;
  metaText?: React.ReactNode;
}

export default function MetaInfoDisplay({ imageSrc = "/images/new-landing-page/img_group.png", metaText = "Meta", ...props }: Props) {
  return (
    <div {...props} className={`${props.className} flex items-center gap-1`}>
      <Img src={imageSrc} alt="Meta" className={`${!!metaText ? "h-[28px]" : "h-[40px] self-end"} object-cover`} />
      <Heading size="headingmd" as="h6" className="text-[26px] font-semibold">
        {metaText}
      </Heading>
    </div>
  );
}
